/*
  Instant add-to-cart -> theme cart drawer.

  Instant pages render add-to-cart buttons as links to a cart permalink
  (/cart/<variant>:1) and handle the click with Instant's own cart logic, which
  either navigates away to the cart or targets an Instant cart this store does
  not use. This intercepts those clicks before Instant sees them, adds the
  variant through the Ajax Cart API, and opens the theme's cart drawer the same
  way the theme's own product form does (the `cart:refresh` event in cart.js).

  Lives outside the Instant section files so republishing from Instant does not
  overwrite it.
*/
(() => {
  const SELECTOR =
    'a[data-instant-action-type="add-to-cart"], a[data-instant-action-type="add-to-instant-cart"]';

  const routes = () => (window.FoxTheme && window.FoxTheme.routes) || {};

  window.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest && event.target.closest(SELECTOR);
      if (!button) return;

      // Without a drawer on the page (cart page, or cart type set to "page"), let Instant handle it.
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if ((button.getAttribute('data-instant-disabled') || '').trim() === 'true') return;
      if (button.getAttribute('aria-busy') === 'true') return;

      const variantId = Number(button.getAttribute('data-instant-action-variant-id'));
      if (!variantId) return;

      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${routes().cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        const result = await response.json();

        if (!response.ok) {
          alert(result.description || result.message || 'This item could not be added to your cart.');
          return;
        }

        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result } }));
        // cart.js re-renders the drawer, publishes cartUpdate (header count), then opens the drawer.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      } catch (error) {
        console.error('Instant add-to-cart failed', error);
        window.location.href = routes().cart_url || '/cart';
      } finally {
        button.removeAttribute('aria-busy');
      }
    },
    true
  );
})();
